import React from 'react';
import { Layout } from '../components/Layout';
import { Container } from '../components/ui/Container';
import { ContactForm } from '../components/ContactForm';
import { Mail, Phone, MapPin, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  return <Layout data-id="element-220">
      <div className="bg-slate-50 py-16 border-b border-slate-200" data-id="element-221">
        <Container className="text-center" data-id="element-222">
          <h1 className="text-4xl font-bold text-slate-900 mb-6" data-id="element-223">Contact Us</h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-224">
            Ready to start your journey to financial clarity? Reach out to
            schedule your consultation.
          </p>
        </Container>
      </div>

      <Container className="py-20" data-id="element-225">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-226">
          <div data-id="element-227">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-228">
              Get in Touch
            </h2>
            <p className="text-slate-600 mb-8 leading-relaxed" data-id="element-229">
              Fill out the form to request a consultation with one of our
              specialists. We'll review your information and get back to you
              within 24 hours to schedule a time that works for you.
            </p>

            <div className="space-y-6 mb-10" data-id="element-230">
              <div className="flex items-start" data-id="element-231">
                <Mail className="h-6 w-6 text-blue-600 mr-4 mt-1" data-id="element-232" />
                <div data-id="element-233">
                  <h3 className="font-semibold text-slate-900" data-id="element-234">Email</h3>
                  <p className="text-slate-600" data-id="element-235">info@danycredit.com</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-236">
                <Phone className="h-6 w-6 text-blue-600 mr-4 mt-1" data-id="element-237" />
                <div data-id="element-238">
                  <h3 className="font-semibold text-slate-900" data-id="element-239">Phone</h3>
                  <p className="text-slate-600" data-id="element-240">786-376-3985</p>
                  <p className="text-sm text-slate-500" data-id="element-241">
                    Mon-Fri, 9am - 6pm EST
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-242">
                <MapPin className="h-6 w-6 text-blue-600 mr-4 mt-1" data-id="element-243" />
                <div data-id="element-244">
                  <h3 className="font-semibold text-slate-900" data-id="element-245">Office</h3>
                  <p className="text-slate-600" data-id="element-246">
                    390 NE 191ST ST STE 8123
                    <br data-id="element-247" />
                    Miami, FL 33179
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-green-50 p-6 rounded-xl border border-green-100" data-id="element-248">
              <div className="flex items-center mb-4" data-id="element-249">
                <MessageCircle className="h-6 w-6 text-green-600 mr-3" data-id="element-250" />
                <h3 className="font-bold text-green-900" data-id="element-251">Quick Question?</h3>
              </div>
              <p className="text-green-800 mb-4 text-sm" data-id="element-252">
                Chat with us on WhatsApp for quick answers to general questions.
              </p>
              <Button className="w-full bg-green-600 hover:bg-green-700 text-white border-none" data-id="element-253">
                Chat on WhatsApp
              </Button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8" data-id="element-254">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-255">
              Request Consultation
            </h2>
            <ContactForm data-id="element-256" />
          </div>
        </div>
      </Container>
    </Layout>;
}